import styled from "styled-components/macro";

export const ImgQtc = styled.img`
grid-area: qtc;
`;